export default function FooterSection() {
  return (
    <footer
      id="section-footer"
      data-section="Footer"
      className="w-full bg-black pt-20 pb-12 px-8 md:px-16"
      style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}
    >
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center gap-10">

        {/* Logo + Brand */}
        <div className="flex flex-col items-center gap-4">
          <img
            src="https://static.readdy.ai/image/6a30e07b0f7694c83ca4df4a3a91c3d2/112bc87945e848609d4c4e0db0f96615.jpeg"
            alt="Urban Blings"
            className="w-14 h-14 rounded-full object-cover"
          />
          <span
            className="font-display font-black uppercase tracking-[0.35em] text-white text-xl"
          >
            Urban Blings
          </span>
          <p className="font-display text-[11px] tracking-[0.3em] uppercase text-white/30">
            Luxury for the Urban Swagger
          </p>
        </div>

        {/* Divider */}
        <div
          className="w-24 h-px"
          style={{ background: 'linear-gradient(90deg, transparent, #C0C0C0, #D4AF37, transparent)' }}
        />

        {/* Social */}
        <div className="flex items-center gap-6">
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="w-10 h-10 flex items-center justify-center border border-white/20 hover:border-white/60 transition-all duration-300 cursor-pointer group"
            aria-label="Urban Blings on Instagram"
          >
            <i className="ri-instagram-line text-white/50 group-hover:text-white text-base transition-colors duration-300" />
          </a>
        </div>

        {/* Nav links */}
        <div className="flex items-center flex-wrap justify-center gap-6 md:gap-8">
          {['Collections', 'About', 'Early Access'].map((link) => (
            <a
              key={link}
              href={link === 'Early Access' ? '#notify' : `#${link.toLowerCase()}`}
              className="font-display text-[10px] tracking-[0.3em] uppercase text-white/30 hover:text-white/70 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              {link}
            </a>
          ))}
        </div>

        {/* Bottom */}
        <div className="flex flex-col items-center gap-2 mt-4">
          <p className="font-sans text-[11px] text-white/20 tracking-wide">
            &copy; 2026 Urban Blings. All rights reserved.
          </p>
          <p className="font-sans text-[10px] text-white/15 tracking-wider">
            Powered by CAC.Zero
          </p>
        </div>

      </div>
    </footer>
  );
}
